export function findEmailAddressesFromString(emailString) {
  const regex = /\S+[a-z0-9]@[a-z0-9\.-]+/gim //eslint-disable-line
  const found = emailString.match(regex)
  if (found) {
    return found
  }
  return []
}
